export default {
  BASE_URL: process.env.BASE_URL,
  API_URL: process.env.VUE_APP_API_URL,
  CULTURE_SECTION: process.env.VUE_APP_CULTURE_SECTION,
  RECAPTCHA_KEY: process.env.VUE_APP_RECAPTCHA_KEY,
  NODE_ENV: process.env.NODE_ENV,
  MAP_ZOOM: process.env.VUE_APP_MAP_ZOOM,
  SENTRY_DNS: process.env.VUE_APP_SENTRY_DNS
};
